import React, { useEffect, useState } from 'react';
import { defaultDepartmentOptions, type DepartmentOption } from '../../systems/user-departments';
import { getActiveWorkspaceHeaders } from '../../systems/workspace-context';
import styles from './auth.module.css';

interface DepartmentPickerProps {
  value: string;
  onChange: (value: string) => void;
  id?: string;
  required?: boolean;
}

const DepartmentPicker: React.FC<DepartmentPickerProps> = ({ value, onChange, id = 'department', required = true }) => {
  const [options, setOptions] = useState<DepartmentOption[]>(defaultDepartmentOptions);

  useEffect(() => {
    let cancelled = false;
    const headers = getActiveWorkspaceHeaders();
    fetch('/api/auth/department-labels', { headers })
      .then((response) => response.json() as Promise<{ departments?: DepartmentOption[] }>)
      .then((data) => {
        if (cancelled || !Array.isArray(data.departments) || data.departments.length === 0) return;
        setOptions(data.departments);
      })
      .catch(() => {
        // Keep default labels if the workspace wording cannot be loaded.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className={styles.inputGroup}>
      <label htmlFor={id}>Votre rôle</label>
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
      >
        <option value="">Sélectionnez un rôle</option>
        {options.map((option) => (
          <option key={option.key} value={option.key}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DepartmentPicker;
